<template>
  <section class="fs-panel-content">
    <div class="dashboard-search">
      <h1 class="h1">Welkom bij FileStore</h1>
      <p class="welcome-text">
        Selecteer links een archief om door uw bestanden te bladeren.
      </p>
    </div>
  </section>
</template>
<script>
export default {
  data() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.h1 {
  color: var(--sub-color);
  margin-bottom: 12px;
}

.fs-home-container-mobile {
  .dashboard-search {
    padding-right: 0;
  }
}

.dashboard-search {
  //width: 550px;
  text-align: center;
  margin: 100px auto;
  padding-right: 160px;
}

.welcome-text {
  line-height: 17px;
}
</style>
